module.exports = __webpack_public_path__ + "static/media/account.bafa13c2.svg";